/**
 * Product Carousel behavior.
 * - Arrow buttons scroll by one viewport-width "page" of cards, using the
 *   track's own native scroll-snap (no custom easing needed — the global
 *   smooth-scroll module only touches vertical page scroll, so this local
 *   horizontal scroll is unaffected and uses the browser's native smooth
 *   scrollBy, which respects prefers-reduced-motion automatically).
 * - Arrows disable at each end rather than wrapping, so it's always clear
 *   there's nothing further to scroll to.
 * - Quick-add posts to /cart/add.js — the header's cart-count module
 *   already listens for this exact request and updates the badge, so
 *   nothing extra is needed here to keep the cart icon in sync.
 */
(function () {
  document.querySelectorAll('[data-product-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-pc-track]');
    var prevBtn = root.querySelector('[data-pc-prev]');
    var nextBtn = root.querySelector('[data-pc-next]');
    if (!track) return;

    function updateArrows() {
      // Fits-detection must run regardless of whether arrow buttons exist —
      // this was the actual bug: the early-return below was only meant to
      // skip arrow-specific disabling, but the class toggle lived in the
      // same function, so turning off arrows in the section's settings
      // silently disabled the even-distribution behavior too.
      var maxScroll = track.scrollWidth - track.clientWidth;
      var fits = maxScroll <= 2;
      track.classList.toggle('pc__track--fits', fits);

      if (!prevBtn && !nextBtn) return;
      if (prevBtn) {
        prevBtn.disabled = fits || track.scrollLeft <= 2;
        prevBtn.style.display = fits ? 'none' : '';
      }
      if (nextBtn) {
        nextBtn.disabled = fits || track.scrollLeft >= maxScroll - 2;
        nextBtn.style.display = fits ? 'none' : '';
      }
    }

    function pageAmount() {
      var firstItem = track.querySelector('.pc__item');
      if (!firstItem) return track.clientWidth * 0.8;
      var itemWidth = firstItem.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      var visibleCount = Math.max(1, Math.floor(track.clientWidth / (itemWidth + gap)));
      return visibleCount * (itemWidth + gap);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -pageAmount(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: pageAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
    window.addEventListener('load', updateArrows);
    setTimeout(updateArrows, 300); // safety net in case layout settles after 'load' (e.g. web fonts, async theme rendering)
    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', updateArrows);
    });

    // ---- Quick add ----
    root.querySelectorAll('[data-pc-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation(); // don't follow the card's link to the product page
        if (btn.hasAttribute('data-pc-loading')) return;

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.setAttribute('data-pc-loading', '');
        var originalLabel = btn.getAttribute('aria-label');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            btn.setAttribute('data-pc-added', '');
            btn.setAttribute('aria-label', 'Added');
            setTimeout(function () {
              btn.removeAttribute('data-pc-added');
              btn.setAttribute('aria-label', originalLabel);
            }, 1800);
          })
          .catch(function (err) {
            // Most common cause: the variant is sold out. Fail quietly in the
            // UI rather than throwing a JS error at the visitor — the product
            // page (which the card still links to) will show the real reason.
            console.warn('Quick add failed:', err && err.message ? err.message : err);
          })
          .finally(function () {
            btn.removeAttribute('data-pc-loading');
          });
      });
    });
  });
})();